import appConfig from 'app-config';
import {getImageSrc} from './lobIconUtil';

export function getAgentPhotoUtil(accountPolicyData) {
    if(!(_.isEmpty(accountPolicyData) && accountPolicyData !== null)){

        var agentImgPathData = {
        "agent1": {
           imagePath: "branding/agent/Abel Pinto 2.png"
         },
         "agent2": {
             imagePath: "branding/agent/Alison Gunn 1.png"
           },
         "agent3": {
            imagePath: "branding/agent/Anthony Grubb 1.png"
          },
          "agent4": {
            imagePath: "branding/agent/Chris Demarest.png"
          },
          "agent5": {
            imagePath: "branding/agent/Chris Down 2.png"
          },
          "agent6": {
            imagePath: "branding/agent/Chris McCullough 1.png"
          },
          "agent7": {
            imagePath: "branding/agent/Craig VanTorre.png"
          },
          "agent8": {
            imagePath: "branding/agent/Dave Hilbert 1.png"
          },
          "agent9": {
            imagePath: "branding/agent/Derek Gillespie 2.png"
          },
          "agent10": {
            imagePath: "branding/agent/Doug Green 1.png"
          },
          "agent11": {
            imagePath: "branding/agent/James White 1.png"
          },
         "agent12": {
             imagePath: "branding/agent/Jamie Sass 2.png"
           },
         "agent13": {
            imagePath: "branding/agent/Jamie Terdik 1.png"
          },
          "agent14": {
            imagePath: "branding/agent/Jeff Holmes.png"
          },
          "agent15": {
            imagePath: "branding/agent/joe-lisk.png"
          },
          "agent16": {
            imagePath: "branding/agent/Jon Richmond 2.png"
          },
          "agent17": {
            imagePath: "branding/agent/Kevin McComb.png"
          },
          "agent18": {
            imagePath: "branding/agent/Kyle Knechtel 2.png"
          },
          "agent19": {
            imagePath: "branding/agent/Kyle Mansbridge.png"
          },
          "agent20": {
            imagePath: "branding/agent/Mark McMahon 2.png"
          },
          "agent21": {
            imagePath: "branding/agent/Marrisa Vickers.png"
          },
          "agent22": {
            imagePath: "branding/agent/Miguel De Sousa 2.png"
          },
          "agent23": {
            imagePath: "branding/agent/Robert (Bobby) Longmuir.png"
          },
          "agent24": {
            imagePath: "branding/agent/Ron Lapointe.png"
          },
          "agent25": {
            imagePath: "branding/agent/Ryan Weis 1.png"
          },
          "agent26": {
           imagePath: "branding/agent/Thomas Mundie.png"
         }
         }

         const agentNameList = {
             'agent1' : ['Abel Pinto'],
             'agent2' : ['Alison Gunn'],
             'agent3' : ['Anthony Grubb'],
             'agent4' : ['Chris Demarest'],
             'agent5' : ['Chris Down'],
             'agent6' : ['Chris McCullough'],
             'agent7' : ['Craig VanTorre'],
             'agent8' : ['Dave Hilbert'],
             'agent9' : ['Derek Gillespie'],
             'agent10' : ['Doug Green'],
             'agent11' : ['James White'],
             'agent12' : ['Jamie Sass'],
             'agent13' : ['Jamie Terdik'],
             'agent14' : ['Jeff Holmes'],
             'agent15' : ['joe-lisk'],
             'agent16' : ['Jon Richmond'],
             'agent17' : ['Kevin McComb'],
             'agent18' : ['Kyle Knechtel'],
             'agent19' : ['Kyle Mansbridge'],
             'agent20' : ['Mark McMahon'],
             'agent21' : ['Marrisa Vickers'],
             'agent22' : ['Miguel De Sousa'],
             'agent23' : ['Robert (Bobby) Longmuir'],
             'agent24' : ['Ron Lapointe'],
             'agent25' : ['Ryan Weis'],
             'agent26' : ['Thomas Mundie'],
             
         }
         var agentDisplayName = accountPolicyData[0].producerContact.organizationDescription;
         const getDataByAgentName = (agentDisplayName) => {
           var agentNames = Object.keys(agentNameList);
           //  console.log(orgNames)
           return _.filter(agentNames, (agentName) => {
            //console.log(orgList[agentName]);
            return agentNameList[agentName].indexOf(agentDisplayName) != -1
          })
         }
        
         const srcPath = agentImgPathData[getDataByAgentName(agentDisplayName)] ? agentImgPathData[getDataByAgentName(agentDisplayName)].imagePath : undefined;
         if(!(_.isUndefined(srcPath))){
            return getImageSrc(srcPath);
         }else{
            return false;
            }
        }
}


